import { useState } from "react";
import Select from "react-select";

const staticPlugins = [
  "Facebook",
  "Slack",
  "Google Ads",
  "Google Analytics",
  "Google Docs",
  "Google Sheets",
  "Google Slides",
  "API",
  "Gemini",
  "Google Web Search",
  "Grok",
  "Mistral",
  "Stable Diffusion",
  "DeepSeek",
  "Perplexity",
  "Claude",
  "Fireflies Transcript",
  "Make",
  "Klaviyo",
  "Shopify",
  "Level Up Marketplace",
  "Clickup",
  "Calendar",
  "Google",
  "Account",
  "Agent",
  "Instagram",
  "Contact",
  "Task",
];

const FilterNav = ({
  sortOrder,
  setSortOrder,
  creatorFilter,
  setCreatorFilter,
  agents,
  pluginsData,
  pluginFilter,
  setPluginFilter,
  activeOnly,
  setActiveOnly,
  companyInfo,
  setSelectTags,
  selectTags,
  
}) => {
  const [enabled, setEnabled] = useState(false);
  const assistTypes = Array.from(
    new Set(agents.map((agent) => agent.assist_type).filter(Boolean))
  );

  const CustomOption = (props) => {
    const { data, innerRef, innerProps } = props;
    return (
      <div
        ref={innerRef}
        {...innerProps}
        className={`flex items-center gap-2 px-3 py-2 cursor-pointer`}
      >
        <input
          type="checkbox"
          id={`checkbox-${data.label}`}
          checked={pluginFilter?.includes(data.label)}
        />
        <label
          className="cursor-pointer whitespace-nowrap truncate"
          htmlFor={`checkbox-${data.label}`}
        >
          {data.label}
        </label>
      </div>
    );
  };

  const CustomTagOption = (props) => {
    const { data, innerRef, innerProps } = props;
    return (
      <div
        ref={innerRef}
        {...innerProps}
        className={`flex items-center gap-2 px-3 py-2 cursor-pointer`}
      >
        <input
          type="checkbox"
          id={`tag-checkbox-${data.value}`}
          checked={
            Array.isArray(selectTags)
              ? selectTags.includes(data.value)
              : selectTags === data.value
          }
        />
        <label
          className="cursor-pointer whitespace-nowrap truncate"
          htmlFor={`tag-checkbox-${data.value}`}
        >
          {data.label}
        </label>
      </div>
    );
  };

  // Custom MultiValue Renderer
  const CustomMultiValue = ({ data }) => {
    return <>{data.label},{' '}</>;
  };

  const getPluginOptionData = () => {
    let data = [];
    pluginsData?.forEach((item) => {
      if (
        !staticPlugins.some((plugin) =>
          item?.name
            ?.toLowerCase()
            ?.includes(plugin.toLowerCase())
        )
      )
        data.push(item?.name?.trim());
    });
    data = [...staticPlugins, ...data].map((item) => ({
      label: item,
      value: item,
    }));
    return data;
  };

  return (
    <div className="flex items-center justify-between w-full text-[#757575] text-sm">
      <div className="flex items-center">
        <select
          className="text-sm px-[15px] py-[14px] !bg-white rounded-[3px] border !border-[#D9D9D9] w-[180px] outline-none"
          value={sortOrder}
          onChange={(e) => setSortOrder(e.target.value)}
        >
          <option value="">Sort By</option>
          <option value="asc">A-Z</option>
          <option value="desc">Z-A</option>
          <option value="createdAt">Date Created</option>
          <option value="updatedAt" >Most Recently Used</option>
        </select>
      </div>

      <div className="flex items-center gap-[31px]">
        {/* <p className="">Filter by:</p> */}
        {/* <Select
          options={getPluginOptionData()}
          placeholder="Plugins"
          isMulti
          closeMenuOnSelect={false}
          hideSelectedOptions={false}
          components={{
            Option: CustomOption,
            MultiValue: CustomMultiValue,
          }}
          classNames={{
            control: () =>
              "border !border-gray-300 shadow-sm rounded py-[5px] w-[250px]",
            multiValue: () => "bg-[#F3F4F6] rounded",
          }}
          onChange={(value) => {
            setPluginFilter(
              value?.length > 0 ? value.map((item) => item.value) : null
            );
          }}
          isClearable
        /> */}

        {/* <Select
          options={
            companyInfo?.SubCategories?.map((type) => ({
              label: type?.name,
              value: String(type?.id),
            })) || []
          }
          placeholder="Select Tags"
          isMulti
          closeMenuOnSelect={false}
          hideSelectedOptions={false}
          components={{
            Option: CustomTagOption,
            MultiValue: CustomMultiValue,
          }}
          classNames={{
            control: () =>
              "border !border-gray-300 shadow-sm rounded py-[5px] w-[143px]",
            multiValue: () => "bg-[#F3F4F6] rounded",
          }}
          onChange={(value) => {
            setSelectTags(
              value?.length > 0 ? value.map((item) => item.value) : []
            );
          }}
          value={
            companyInfo?.SubCategories?.filter((type) =>
              Array.isArray(selectTags)
                ? selectTags.includes(String(type?.id))
                : selectTags === String(type?.id)
            )?.map((type) => ({
              label: type?.name,
              value: String(type?.id),
            })) || []
          }
          isClearable
        /> */}

        {/* <select
          className="text-sm px-[15px] py-[14px] rounded-[3px] !bg-white border !border-[#D9D9D9] w-[143px] outline-none"
          value={creatorFilter}
          onChange={(e) => setCreatorFilter(e.target.value)}
        >
          <option value="">Creator</option>
          {assistTypes.map((type, i) => (
            <option key={i} value={type}>
              {type}
            </option>
          ))}
        </select> */}

        <div className="flex items-center ">
          <button
            type="button"
            onClick={() => setActiveOnly(!activeOnly)}
            className={`relative inline-flex h-6 w-11 items-center rounded-full transition-colors ${
              activeOnly ? "bg-[#009951]" : "bg-gray-300"
            }`}
          >
            <span
              className={`inline-block h-4 w-4 transform rounded-full bg-white transition-transform ${
                activeOnly ? "translate-x-6" : "translate-x-1"
              }`}
            />
          </button>

          <p className="pl-[10px] text-sm">
            {activeOnly ? "Active" : "Inactive"} Agents
          </p>
        </div>
      </div>
    </div>
  );
};

export default FilterNav;
